const imageGallery = document.querySelectorAll('[data-slider="image-gallery__slider"]');

const imageGalleryOptions = {
  slidesPerView: 1.2,
  spaceBetween: 16,
  speed: 800,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 'auto',
      spaceBetween: 24,
    },
  },
};

imageGallery.forEach((el) => {
  const parentElem = el.closest('.image-gallery');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');

  imageGalleryOptions.navigation.prevEl = arrowLeft;
  imageGalleryOptions.navigation.nextEl = arrowRight;

  new Swiper(el, imageGalleryOptions);
});
